import React from 'react'

export default function getCodePieces (response) {
  return response.split('<').map((res, i) => {
      var index = res.indexOf('>')
      if (index !== -1) {
          return <code key={i}><var>{res.substr(0, index)}</var>{res.substr(index+1)}</code>
      }
      else return res
  })
}

